import { gql } from "@apollo/client";

export default gql`
  mutation updateCustomer(
    $_id: String
    $disabled: Boolean
    $name: String
    $nameAr: String
    $phone: String
    $mobile: String
    $email: String
    $address: String
    $avatar: String
    $logo: String
    $houseno: String
  ) {
    updateCustomer(
      _id: $_id
      disabled: $disabled
      name: $name
      nameAr: $nameAr
      phone: $phone
      mobile: $mobile
      email: $email
      address: $address
      avatar: $avatar
      logo: $logo
      houseno: $houseno
    ) {
      ok
      message
      data
      error
    }
  }
`;
